import { render, staticRenderFns } from "./ScoreChart.vue?vue&type=template&id=34f02ce8&scoped=true&"
import script from "./ScoreChart.vue?vue&type=script&lang=js&"
export * from "./ScoreChart.vue?vue&type=script&lang=js&"
import style0 from "./ScoreChart.vue?vue&type=style&index=0&id=34f02ce8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f02ce8",
  null
  
)

export default component.exports